import PopupBackground from "../popup-background"

import { IoMdClose } from "react-icons/io"

export default function PopupContact(props: {
  visibility: boolean
  handleClose: () => void
}) {
  return (
    <PopupBackground visibility={props.visibility} id="popupContact">
      <form className="flex flex-col items-center h-fit max-w-2xl bg-[#FAFAF5] w-full rounded-2xl border border-[#E6E6E6]">
        <div className="relative flex flex-col items-center flex-1 w-full py-3">
          <h1 className="text-3xl font-semibold underline">Kontakty</h1>
          <IoMdClose
            className="absolute z-30 w-7 h-7 right-4 top-4 hover:stroke-4 hover:cursor-pointer hover:fill-red-700"
            onClick={props.handleClose}
          />
        </div>
        <div className="flex flex-col items-start justify-start w-full px-10 py-3 gap-x-5 h-fit">
          <h2 className="font-medium">ALTEN s.r.o.</h2>
          <p className="pl-5">
            Raškovice 506 <br /> 739 04 Raškovice - Raškovice
          </p>
          <h3 className="pt-2">
            <span className="font-medium">IČO:</span> 60323094
          </h3>
          <h3 className="pt-2">
            <span className="font-medium">Kontaktní osoba: </span> Aneta
            Horečková
          </h3>
          <h3 className="pt-2">
            <span className="font-medium">Telefoní číslo: </span> +420 606 761
            861
          </h3>
          <h3 className="py-2">
            <span className="font-medium">Email: </span>{" "}
            <a
              className="underline hover:cursor-pointer hover:font-medium"
              href="mailto:info@altencz.cz"
            >
              info@altencz.cz
            </a>
          </h3>
        </div>
      </form>
    </PopupBackground>
  )
}
